'use strict';

exports.__esModule = true;
var DefaultFontColor = '#333333';

var Main = '#E62427';
var Orange = '#F19840';
var Blue = '#2E7AC3';
var BlueLight = '#14A5FF';
var Green = '#008675';
var DarkGreen = '#009688';

var Red = '#E62427';
var Red2 = '#EB5052';
var Red3 = '#EF7C7E';
var Red4 = '#F5A7A7';
var Red5 = '#F9D3D4';

var Yellow = '#EEE552';
var Yellow2 = '#F1E976';
var Yellow3 = '#F5EF99';
var Yellow4 = '#F9F5BB';
var Yellow5 = '#FDF9DE';

var Dark = '#565151';
var Dark2 = '#6C6666';
var Dark3 = '#8A807F';
var Dark4 = '#A79E9D';
var Dark5 = '#C6BDBC';
var Dark6 = '#E2DFDE';
var Dark7 = '#F0EFEE';
var Dark8 = '#FDF3F3';

// 轉換公式
function hex(x) {
   return ("0" + parseInt(x, 10).toString(16)).slice(-2);
}

// 1 ~ 100 變亮
// -1 ~ -100 變暗
function LightenDarkenColor(col, amt) {

   var usePound = false;

   if (col[0] === "#") {
      col = col.slice(1);
      usePound = true;
   }

   var num = parseInt(col, 16);

   var r = (num >> 16) + amt;

   if (r > 255) r = 255;else if (r < 0) r = 0;

   var b = (num >> 8 & 0x00FF) + amt;

   if (b > 255) b = 255;else if (b < 0) b = 0;

   var g = (num & 0x0000FF) + amt;

   if (g > 255) g = 255;else if (g < 0) g = 0;

   var _hex = (g | b << 8 | r << 16).toString(16);
   if (_hex.length !== 6) {
      return (usePound ? "#" : "") + (hex(r) + hex(g) + hex(b));
   } else {
      return (usePound ? "#" : "") + _hex;
   }
}

function RGBA(_hex, opacity) {

   // http://stackoverflow.com/a/5624139
   var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
   _hex = _hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
   });

   var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(_hex);
   result = result ? 'rgba(' + parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16) + ',' + opacity + ')' : null;
   return result;
}

var Colors = {
   /*--------------------------
   	Variable
   --------------------------*/
   DefaultFontColor: DefaultFontColor,
   Main: Main,
   Orange: Orange,
   Blue: Blue,
   BlueLight: BlueLight,
   Green: Green,
   DarkGreen: DarkGreen,
   Red: Red,
   Red2: Red2,
   Red3: Red3,
   Red4: Red4,
   Red5: Red5,
   Yellow: Yellow,
   Yellow2: Yellow2,
   Yellow3: Yellow3,
   Yellow4: Yellow4,
   Yellow5: Yellow5,
   Dark: Dark,
   Dark2: Dark2,
   Dark3: Dark3,
   Dark4: Dark4,
   Dark5: Dark5,
   Dark6: Dark6,
   Dark7: Dark7,
   Dark8: Dark8,

   /*--------------------------
   	Method
   --------------------------*/
   LightenDarkenColor: LightenDarkenColor,
   RGBA: RGBA
};

exports.default = Colors;
module.exports = exports['default'];